// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"ed706691","467":"d8c77647"}[chunkId] + ".chunk.js";
};